import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ManualApplicationSearchParams } from '@shared/api';
import { Input, useDebounce } from '@shared';

interface Props {
  onSubmit(search: ManualApplicationSearchParams): void;
}

export const ManualApplicationSearchForm = (props: Props) => {
  const [filterCriteria, setFilterCriteria] = useState<ManualApplicationSearchParams>({});

  const debouncedFilterCriteria = useDebounce(filterCriteria, 500);
  useEffect(() => {
    props.onSubmit(debouncedFilterCriteria);
  }, [debouncedFilterCriteria]);

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Grid container>
        <Grid item xs={12}>
          <Input
            name='keyword'
            label='Application Reference'
            fullWidth
            value={filterCriteria.name || ''}
            onChange={(e) => setFilterCriteria((prev) => ({ ...prev, name: e.target.value }))}
          />
        </Grid>
      </Grid>
    </form>
  );
};
